import * as React from 'react';
import {
    Create,
    TextInput,
    required,
    SimpleForm,
    SelectInput,
    NullableBooleanInput,
    useCreate,
    FormDataConsumer,
    NumberInput,
    AutocompleteInput,
} from 'react-admin';
import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import { useNavigate, useSearchParams } from 'react-router-dom';
import FileUpload from '../../common/inputs/FileUpload';
import { CONTENT_TYPES, STATUS } from '../../common/constants';
import { useState, useMemo, useEffect } from 'react';
import VideoAutocompleteInput from '../../common/inputs/VideoAutocompleteInput';
import PdfAutocompleteInput from '../../common/inputs/PdfAutoCompleteInput';
import PdfUrlPrefilled from '../../common/inputs/PdfUrlPrefilled';
import AddExerciseAutoComplete from '../../common/inputs/AddExerciseAutoComplete';

const ContentCreate = () => {
    const [create, { isLoading }] = useCreate();
    let { programId, subjectId, chapterId, topicId } = useParams();
    const [selectedPdfUrl, setSelectedPdfUrl] = useState<string | null>('');
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const defaultValues = useMemo(
        () => ({
            programId: programId,
            subjectId: subjectId,
            topicId: topicId,
            type: searchParams.get('type'),
            chapterId: chapterId,
        }),
        [programId, subjectId, topicId, chapterId, searchParams],
    );

    const submitContentCreate = (data: any) => {
        if (isLoading) {
            return;
        }

        const contentsData: any = {
            ...data,
            ...(data.type === 'NOTES' && selectedPdfUrl && { pdfUrl: selectedPdfUrl }),
        };
        create(
            'contents',
            { data: contentsData },
            {
                onSuccess: () => {
                    navigate(-1);
                },
            },
        );
    };

    if (!subjectId || !searchParams.get('type')) {
        return <LoadingSection />;
    }

    return (
        <Create
            // @ts-ignore
            redirect={() => {
                navigate(-1);
            }}
            resource={'contents'}
        >
            <SimpleForm defaultValues={defaultValues} onSubmit={submitContentCreate}>
                <TextInput source="title" fullWidth validate={[required()]} />
                <FileUpload
                    type="VIDEO_THUMBNAIL"
                    label={'Thumbnail'}
                    source="thumbnail"
                    accept={'image/*'}
                />
                <SelectInput
                    source="status"
                    label={'Status'}
                    fullWidth
                    validate={[required()]}
                    choices={STATUS}
                />
                <AutocompleteInput
                    source="type"
                    validate={[required()]}
                    label={'Type'}
                    fullWidth
                    readOnly={true}
                    choices={CONTENT_TYPES}
                />
                <FormDataConsumer>
                    {({ formData, ...rest }) => {
                        if (formData.type === 'EXERCISES') {
                            return (
                                <>
                                    <AddExerciseAutoComplete
                                        fullWidth
                                        formData={formData}
                                        source={'exerciseId'}
                                    />
                                </>
                            );
                        }
                        if (formData.type === 'LECTURES') {
                            return (
                                <>
                                    <VideoAutocompleteInput
                                        type={'VIDEOS'}
                                        fullWidth
                                        formData={formData}
                                        source={'videoId'}
                                    />
                                    <NumberInput
                                        source="restrictionMaxDurationMultiple"
                                        type={'number'}
                                        fullWidth
                                    />
                                    <NumberInput
                                        source="restrictionMaxNumberPlayback"
                                        type={'number'}
                                        fullWidth
                                    />
                                </>
                            );
                        }
                        if (formData.type === 'NOTES') {
                            return (
                                <>
                                    <PdfAutocompleteInput
                                        type={'NOTES'}
                                        fullWidth
                                        formData={formData}
                                        source={'pdfId'}
                                        selectedPdfUrl={selectedPdfUrl}
                                        setSelectedPdfUrl={setSelectedPdfUrl}
                                    />

                                    <PdfUrlPrefilled
                                        fullWidth
                                        formData={formData}
                                        source={'pdfUrl'}
                                        selectedPdfUrl={selectedPdfUrl}
                                    />
                                </>
                            );
                        }
                        return <></>;
                    }}
                </FormDataConsumer>
                <NullableBooleanInput source={'isDemo'} fullWidth label={'Is Demo'} />
                <NumberInput source="displayOrder" type={'number'} fullWidth />
            </SimpleForm>
        </Create>
    );
};

export default ContentCreate;
